module.exports = __webpack_public_path__ + "img/logo18.98d79ba6.jpg";